import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M8c — LARVE. La feuille de la chaîne de ponte.
 *
 *  Ce qui sort de l'œuf : une petite chose vive qui pique vers le bas en lâchant
 *  un tir visé, puis file hors du terrain. Elle ne pond RIEN — c'est ce qui
 *  termine la chaîne Pondeuse → Œuf → Larve et empêche l'engendrement de se
 *  propager sans fin.
 *
 *  ── Ce qu'elle enseigne ──
 *  Le coût de l'inaction en amont. Prise isolément, une Larve est triviale ; par
 *  quatre, écloses en même temps près du joueur, elles saturent son attention au
 *  moment précis où il aurait dû s'occuper de la Pondeuse. La Larve n'est pas une
 *  leçon en soi — elle est la FACTURE d'une Pondeuse ou d'œufs laissés en vie, et
 *  c'est ce qui donne du sens à la priorité de cible que la Pondeuse enseigne.
 *
 *  ── Pourquoi elle est fragile mais mordante ──
 *  Quarante points de vie, un tir visé rapide : abattable d'une volée, mais elle
 *  pique et tire assez pour qu'un essaim non anticipé fasse mal. Elle naît déjà
 *  bas (à hauteur de l'œuf qui l'a couvée), donc proche — sa descente est courte
 *  et le temps de réaction, bref. */
export default defineEnemy({
  id: 'larve',
  rank: Rank.Popcorn,
  hp: 40,
  visualRadius: 16,
  score: 60,
  telegraph: 0.4,
  drops: 1,
  // Pique vers le bas : elle naît près du joueur et fond dessus.
  motion: { kind: Motion.Linear, speed: 320 },
  emitter: {
    pattern: Pattern.Aimed,
    every: 1.5,
    count: 1,
    speed: 420,
    firstDelay: 0.6,
    family: Fam.EnemyRed,
  },
});
